export default __webpack_public_path__ + "static/media/warning--domestic-animals--g2.1c50b229.png";